const ROUTE_BY_ACTION: Record<string, string> = {
  "sign-in": "/sign-in",
  "enter-code": "/enter-code",
  "sign-out": "/sign-out",
  "reset-password": "/reset-password",
  "forgot-password": "/forgot-password",
};

/**
 * The login screens used to be selected by `?action=…` on the app index; they
 * are routes now. Maps a legacy URL to its route, keeping every other param
 * (`to`, `url_logged`, the `code`/`email` of a reset link, the workspace
 * params…). Returns null when the URL carries no known action.
 *
 * The action is read from the query, or from the hash when a hash router put
 * the query after `#` (`#/path?action=sign-out`).
 */
export function resolveLegacyActionUrl(
  href: string,
  basepath: string,
): string | null {
  const url = new URL(href);
  const hashQueryIndex = url.hash.indexOf("?");
  const fromHash =
    !url.searchParams.has("action") && hashQueryIndex >= 0
      ? new URLSearchParams(url.hash.slice(hashQueryIndex + 1))
      : null;
  const action = (fromHash ?? url.searchParams).get("action");
  const route = action === null ? undefined : ROUTE_BY_ACTION[action];
  if (!route) {
    return null;
  }

  const target = new URL(url.origin);
  target.pathname = `${basepath.replace(/\/+$/, "")}${route}`;
  for (const params of [url.searchParams, fromHash]) {
    for (const [name, value] of params ?? []) {
      if (name !== "action") {
        target.searchParams.append(name, value);
      }
    }
  }
  return target.toString();
}
